// extracted by mini-css-extract-plugin
export default {"hostContainer":"z74MYUCXOJ","iframe":"UQHt86hiCO"};